module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "pay-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.payOrder
    }
  }, [_vm._v("付款 " + _vm._s(_vm.countText))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-337b0e2c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/countdown.vue
// module id = 562
// module chunks = 1